const Title: React.FC<{ lessonTitle: string }> = ({ lessonTitle }) => {
  return <h1 className='md:text-xl font-semibold text-zinc-700'>{lessonTitle}</h1>;
};

export default Title;
